<template>
  <div>
    <template v-if="pattern=='model'">
      必填
      <Checkbox label="必填" v-model="content.must"></Checkbox>
      <Input style="width:100px" v-model="content.title" :disabled="$route.name!='approvalCreate'" placeholder="请输入标题"></Input>
    </template>
    <div style="display: inline-block;width:100px;text-align: right;vertical-align: top;" v-else>{{content.title}}<span style="color: red" v-if="content.must">*</span></div>
    ：
    <template v-if="pattern=='model'">
      <CheckboxGroup  :disabled="true" v-model="content.selected" style="max-width:350px;vertical-align: middle;display: inline-block">
        <template v-for="(item,index) in content.label">
          <Poptip title="修改选项" trigger="hover">
            <Checkbox :disabled="true" :label="item"></Checkbox>
            <Row slot="content" type="flex" align="middle">
              <Col span="20"><Input v-model="content.label[index]"></Input></Col>
              <Col span="4"><Icon class="close-icon" type="md-close-circle" @click="content.label.splice(index,1)"></Icon></Col>
            </Row>
          </Poptip>
        </template>
      </CheckboxGroup>
      <Icon class="close-icon" style="color:#19be6b" type="md-add-circle" @click="content.label.push('多选文字')"></Icon>
      <Icon class="close-icon" type="md-close-circle" @click="$emit('del',index)"></Icon>
    </template>
    <template v-else>
      <!-- <CheckboxGroup  :disabled="pattern!='submission'" v-model="content.selected" style="max-width:350px;vertical-align: middle;display: inline-block"> -->
      <CheckboxGroup  v-if="pattern=='submission'" v-model="content.selected" style="max-width:350px;vertical-align: middle;display: inline-block">
        <template v-for="(item,index) in content.label">
          <!-- <Checkbox :disabled="pattern!='submission'" :label="item"></Checkbox> -->
          <Checkbox :label="item"></Checkbox>
        </template>
      </CheckboxGroup>
      <span v-else><span v-for="(item,index) in content.selected">{{item}}<span v-if="index>=0&&index<content.selected.length-1">、</span></span></span>
    </template>
  </div>
</template>

<script>
  export default {
    name: "approvalCheckbox",//多选框
    props:{
      index:Number,
      pattern:String,
      contentIn:Object,
    },
    data:function () {
      return{
        content:{
          title:'',
          selected:[],
          label:[],
          must:false,
          allowSubmission:false,
        },
      }
    },
    mounted:function () {
      if(this.contentIn.title!=undefined){
        this.content = this.contentIn
      }
    },
    watch:{
      content:{
        handler(){
          if(this.content.must!=true||this.content.selected.length>0){
            this.content.allowSubmission = true
          }else{
            this.content.allowSubmission = false
          }
          this.$emit('change',this.content)
        },
        deep:true,
        immediate:true,
      }
    }
  }
</script>